<template>
  <div>
    <ModalHeader
      :handleClose="handleClose"
      :showClose="true"
    />
    <div
      :class="[$style.modalBody, $style.contentWrapper]"
    >
      <HeadingHuge :class="$style.center">
        {{ icon }}
      </HeadingHuge>
      <HeadingLarge :class="$style.center">
        {{ headerText }}
      </HeadingLarge>
      <p>
        {{ subHeaderText }}
      </p>
      <p>
        <strong>{{ bodyText }}</strong>
      </p>
      <div :class="[$style.buttonGroup, $style.center]">
        <Button
          dataTestId="PaymentInfoModal__buttonHandleNextStep"
          text="Add payment info"
          @click="handleAddPaymentInfoButtonClicked"
        />
        <ExternalLink
          href="mailto:sales@jumpcloud.com"
          :showExternalLinkIcon="false"
          text="Contact us"
          @click="handleContactSalesButtonClicked"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BodyComponentConsts } from 'client/util/Constants';
import {
  Button,
  HeadingHuge,
  HeadingLarge,
} from '@jumpcloud/ui-components';
import { eventLocations, eventProperties, paymentModalNames } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ExternalLink from 'client/components/ExternalLink.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';
import ModalHeader from 'components/Modal/ModalComponents/ModalHeader.vue';
import PaymentStepMixin from 'client/Payments/mixins/PaymentStepMixin';

const { emojiUnicode } = BodyComponentConsts;

const {
  description,
  location,
  section,
} = eventProperties;

export default {
  name: 'PaymentInfoForNoCCModal',

  EventHelper,

  components: {
    Button,
    ExternalLink,
    HeadingHuge,
    HeadingLarge,
    ModalHeader,
  },

  mixins: [PaymentStepMixin],

  data: () => ({
    bodyText: 'Please add payment information to continue using JumpCloud.',
    headerText: 'Thanks for joining JumpCloud!',
    icon: emojiUnicode.wave,
    modalName: paymentModalNames.paymentInfoForNoCCModal, // to send with Segment events
    subHeaderText: 'We noticed that you don\'t have any payment information added to your JumpCloud account.',
  }),

  methods: {
    handleAddPaymentInfoButtonClicked() {
      this.handleNextStep();
    },

    handleClose() {
      this.$options.EventHelper.triggerModalViewed({
        [description]: 'Payment Information modal for customers without credit card',
        [location]: eventLocations.paymentInfoForNoCCModal,
        [section]: 'Add payment info to account',
      });
      ModalEventBus.close();
    },

    handleContactSalesButtonClicked() {
      this.handleEmailSalesLinkClicked('PaymentInfoForNoCCModal');
      this.handleClose();
    },
  },
};
</script>

<style module>
.buttonGroup {
  margin-top: 3em;
}

.buttonGroup > button {
  margin-right: 1em;
}

.center {
  text-align: center;
}

.contentWrapper {
  margin: 0 auto;
}

.modalBody {
  padding: 0 5rem 5em;
}

@media (min-width: 374px) {
  .contentWrapper {
    max-width: 95%;
  }

  .modalBody {
    padding: 0 2rem 5em;
  }
}

@media (min-width: 768px) {
  .contentWrapper {
    max-width: 90%;
  }
}

@media (min-width: 992px) {
  .contentWrapper {
    max-width: 75%;
  }
}

@media (min-width: 1200px) {
  .contentWrapper {
    max-width: 66%;
  }
}

</style>
